import React from 'react';
import "./Header.css"


const Header = () => {
	return (
		<div className="header">
			<img className='img1' src="https://cdn.grupoelcorteingles.es/SGFM/contents/images/uploads/2019/10/5da98a744554046e9a227de7.gif" alt="" />
		</div>
	);
};

export default Header;
